export const PAGE_CONFIG = {
  "name": "CommonPermissionWrap",
  "children": [
    {
      "name": "OpinonsWrap",
      "config": {
        "logConfig": {
          "pageId": "102001",
          "pageName": "opinions-v3",
          "extInfo": "opinions-v3",
          "pagePath": "/opinionIndex",
          "typeId": "studio_pc"
        }
      },
      "children": [
        {
          "name": "OpinionsFilter",
          "children": [
            {
              "name": "CommonRow",
              "className": "dhb-studio-opinions-gamestore-community-wrap dhb-studio-ggg-opinions-gamestore-community-wrap",
              "type": "layout",
              "props": {},
              "children": [
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 15
                  },
                  "children": [
                    {
                      "name": "GameStore",
                      "config": {
                        "isDelay": true
                      }
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "dhb-studio-opinions-gamestore-community-wrap",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 9
                  },
                  "children": [
                    {
                      "name": "CommunityPerformance",
                      "tooltipMaxTop": 340,
                      "config": {
                        "isDelay": true
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "StudioTrendingVideo",
              "className": "dbh-studio-opinions-v3-trending-video",
              "config": {
                "language": "origin"
              }
            },
            {
              "name": "CommonRow",
              "className": "dhb-studio-opinions-gamestore-community-wrap",
              "type": "layout",
              "props": {},
              "children": [
                {
                  "name": "CommonCol",
                  "className": "dhb-studio-opinions-language-channel-community-wrap",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 12
                  },
                  "children": [
                    {
                      "name": "LanguageChannel",
                      "config": {
                        "isDelay": true
                      }
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 6
                  },
                  "children": [
                    {
                      "name": "PR",
                      "config": {
                        "isDelay": true
                      }
                    }
                  ]
                },
                {
                  "name": "CommonCol",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {
                    "w": 6
                  },
                  "children": [
                    {
                      "name": "GoogleTrends",
                      "config": {
                        "isDelay": true
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};